function ImpactContent() {
    return (
        <div> 
            <div className="mb-3  fw-semibold" style={{borderColor: "rgba(9, 26, 58, 1)" }}>★★★</div>

            <p className="text-uppercase text-muted mb-2">
                Tamil Nadu Warehousing Corporation
            </p>

            <h2 className="fw-bold display-6 mb-4">
                Together, We Strengthen <br />
                Tamil Nadu’s Supply Chain
            </h2>

            <p className="text-muted mb-4">
                Tamil Nadu Warehousing Corporation supports agriculture, industries,
                and trade by providing modern, secure, and efficient storage
                infrastructure across the state.
            </p>

            <ul className="impact-list mb-4">
                <li>Improved agricultural storage efficiency</li>
                <li>Reduced post-harvest losses</li>
                <li>Faster logistics and distribution</li>
                <li>Support for farmers and industries</li>
            </ul>

            <button className="btn  learn-more-btn px-4">

                Learn More
            </button>
        </div>
    );
}

export default ImpactContent;
